import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

class Amount extends React.Component {

  render() {
    const {amount} = this.props;

    if (amount === undefined){
      return null;
    }

    const formatted = new Intl.NumberFormat('fr-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);

    return <span>{formatted}</span>;
  }
}

export default injectIntl(Amount);

Date.propTypes ={
  amount: PropTypes.number
};

